import * as yup from "yup";

const FormSchemaValidations = yup.object().shape({

  typeEntity: yup
    .mixed()
    .required("El tipo de persona es obligatorio"),
  /*clientCode: yup
    .string()
    .required("El código de cliente es obligatorio"),*/
  receiverName: yup.string().required("El nombre de cliente es obligatorio"),
  dteType: yup.mixed().required("El documento a emitir es obligatorio"),

  tradeName: yup.string().required("El nombre comercial es obligatorio"),

  economicActivity: yup.mixed().required("La actividad económica es obligatoria"),
  //largeConsumer: yup.mixed().required("El tipo de contribuyente es obligatorio"),

  largeConsumer: yup.mixed().when("dteType.value", {
    is: value => value === '15',
    then: yup.mixed().required("El tipo de contribuyente es obligatorio"),
    otherwise: yup.mixed().nullable(),
  }),

  country: yup.mixed().when('dteType.value', {
    is: value => value === '11',
    then: yup.mixed().required("El país es obligatorio"),
    otherwise: yup.mixed().nullable()
  }),

  dui: yup.string().when("dteType.value", {
    is: value => value === "01",
    then: yup.string().required("El DUI es obligatorio"),
    otherwise: yup.string().nullable(),
  }),
  
  nit: yup.string().when("dteType.value", {
    is: value => value !== "01",
    then: yup.string().required("El NIT es obligatorio"),
    otherwise: yup.string().nullable(),
  }),

  nrc: yup.string().when("dteType.value", {
    is: value => value === "15",
    then: yup.string().required("El NRC es obligatorio"),
    otherwise: yup.string().nullable(),
  }),

  department: yup.mixed().when('dteType.value', {
    is: value => value !== '11',
    then: yup.mixed().required("El departamento es obligatorio"),
    otherwise: yup.mixed().nullable()
  }),
  municipality: yup.mixed().when('dteType.value', {
    is: value => value !== '11',
    then: yup.mixed().required("El municipio es obligatorio"),
    otherwise: yup.mixed().nullable()
  }),
  district: yup.mixed().when('dteType.value', {
    is: value => value !== '11',
    then: yup.mixed().required("El distrito es obligatorio"),
    otherwise: yup.mixed().nullable()
  }),

  address: yup.string().required("La direccion es obligatoria"),

  receiverPhoneNumber: yup
    .string()
    .matches(
      /^\+[0-9]{8,15}$/,
      'El número de teléfono debe ser válido y debe incluir el prefijo internacional con "+"'
    )
    .required('El número de teléfono es obligatorio'),
  receiverEmail: yup
    .string()
    .email("No es un correo válido")
    .required("El correo electrónico es obligatorio"),
});

export default FormSchemaValidations;
